export const JOB_APPLICATION_STATUSES = [
    "ACTIVE",
    "WITHDRAWN",
    "ACCEPTED",
    "REJECTED",
];
/** Every legal `stable_job_applications.status` transition
 * (`docs/products/stable.md` "Hire"). `ACTIVE` is the only non-terminal
 * state — the applicant can withdraw, or the posting Stable can decide
 * (accept/reject); a decided or withdrawn application never transitions
 * again (the applicant may instead submit a brand-new application, which
 * the partial-unique DB index allows once the prior one is no longer
 * `ACTIVE`). */
const LEGAL_TRANSITIONS = {
    ACTIVE: ["WITHDRAWN", "ACCEPTED", "REJECTED"],
    WITHDRAWN: [],
    ACCEPTED: [],
    REJECTED: [],
};
export function canTransitionApplication(from, to) {
    return LEGAL_TRANSITIONS[from].includes(to);
}
export const JOB_POSTING_STATUSES = ["OPEN", "CLOSED"];
export const JOB_POSTING_TITLE_MAX_LENGTH = 160;
export const JOB_POSTING_DESCRIPTION_MAX_LENGTH = 4_000;
/** A posting only accepts new applications while `OPEN`
 * (`docs/products/stable.md` "Hire": postings are Stable-managed and
 * applicants apply against "open" postings). */
export function isOpenForApplications(status) {
    return status === "OPEN";
}
